/*
 *
 * AllottedCasesDetailsPage reducer
 *
 */
import produce from "immer";
import { DEFAULT_ACTION, CASEDETAILS, SET_RERENDER } from "./constants";

export const initialState = {
  apiReRender: false,
};

/* eslint-disable default-case, no-param-reassign */
const allottedCasesDetailsPageReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case DEFAULT_ACTION:
        break;
      case CASEDETAILS:
        draft.caseDetails = action.payload
        break;
      case SET_RERENDER:
        return {
          ...state,
          apiReRender: action.payload,
        };
      default:
        return state
    }
  });

export default allottedCasesDetailsPageReducer;
